// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"528c940b","404":"2d069550","498":"4fd7edfe","513":"4fffbe32","832":"eb041625"}[chunkId] + ".chunk.js";
};